<div class="create-connection-form">
  <!-- Connection Type Selection -->
  <mat-form-field class="col__"
                  [appHide]="entityConnectionType">
    <mat-label>Choose an entity type to connect to...</mat-label>
    <mat-select placeholder="Entity Type"
                name="entityType"
                class="capitalize"
                [formControl]="entityConnectionTypeInput"
                [disableRipple]="true"
                [compareWith]="compareByIdFn">
      <mat-option *ngFor="let ect of entityConnectionOptions"
                  [value]="ect"
                  class="capitalize">
        {{getOppositeEntityType(ect)?.nameSingular}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Entity Search/Selection -->
  <app-entity-autocomplete *ngIf="toEntityType && !selectedEntity"
                           [labelText]="'Search for a ' + toEntityType.nameSingular"
                           [allowCreateNew]="true"
                           [excludeEntitiesFn]="excludeEntitiesFn(fromEntityId)"
                           [entityTypeIds]="[toEntityType.id]"
                           [campaignId]="campaignId"
                           (entitySelected)="entitySelected($event)">
  </app-entity-autocomplete>

  <!-- Selected Entity Display -->
  <div class="results__entity flex flexJustify--between flexAlign--center"
       *ngIf="selectedEntity">
    <app-entity-avatar [assessmentLevel]="selectedEntity.currentAssessmentLevel"
                       [spotlightIcon]="selectedEntity.spotlightIcon"
                       [entityTypeId]="selectedEntity.entityTypeId"
                       size="sm">
    </app-entity-avatar>
    <div class="results__main pr-0200">
      <app-entity-name [entity]="selectedEntity"></app-entity-name>
      <span class="results__location"
            *ngIf="selectedEntity.bestAddress">{{selectedEntity?.bestAddress | cityState}}</span>

      <div class="results__clear">
        <button class="link color--red"
                (click)="selectedEntity = null; _updateValue()">
          <i class="fal fa-trash-alt"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Note Field -->
  <mat-form-field class="col__"
                  *ngIf="selectedEntity">
    <mat-label>Connection Note</mat-label>
    <textarea matInput
              [formControl]="noteInput"></textarea>
  </mat-form-field>
</div>
